interface Environment {
  production: boolean;
  apiUrl: string;
  firebaseConfig: {
    apiKey: string;
    authDomain: string;
    projectId: string;
    storageBucket: string;
    messagingSenderId: string;
    appId: string;
  };
}

const environments: Record<string, Environment> = {
  local: {
    production: false,
    apiUrl: '/api',
    firebaseConfig: {
      apiKey: 'AIzaSyBuy9KVjIvR5ntZHd7gs0iOl4XPvqAGhuE',
      authDomain: 'smarsheetbackup-dev.firebaseapp.com',
      projectId: 'smarsheetbackup-dev',
      storageBucket: 'smarsheetbackup-dev.appspot.com',
      messagingSenderId: '437000505507',
      appId: '1:437000505507:web:baeb0cbb7920f3985e1716',
    },
  },
  dev: {
    production: false,
    apiUrl: 'https://proxy-437000505507.europe-west1.run.app',
    firebaseConfig: {
      apiKey: 'AIzaSyBuy9KVjIvR5ntZHd7gs0iOl4XPvqAGhuE',
      authDomain: 'smarsheetbackup-dev.firebaseapp.com',
      projectId: 'smarsheetbackup-dev',
      storageBucket: 'smarsheetbackup-dev.appspot.com',
      messagingSenderId: '437000505507',
      appId: '1:437000505507:web:baeb0cbb7920f3985e1716',
    },
  },
  prod: {
    production: true,
    apiUrl: 'https://proxy-592475272803.europe-west1.run.app',
    firebaseConfig: {
      apiKey: 'AIzaSyDSZ8lArHTvBHrhYW5RnztVDPSZ89XV0Dc',
      authDomain: 'klonup-prod.firebaseapp.com',
      projectId: 'klonup-prod',
      storageBucket: 'klonup-prod.firebasestorage.app',
      messagingSenderId: '592475272803',
      appId: '1:592475272803:web:4bb00247458213d434aa56',
    },
  },
};

function detectEnvironment(): Environment {
  const hostname = typeof window !== 'undefined' ? window.location.hostname : 'localhost';

  if (hostname === 'localhost') return environments.local;
  if (hostname.includes('smarsheetbackup-dev')) return environments.dev;
  if (hostname.includes('klonup-prod') || hostname.includes('klonup.com')) return environments.prod;

  return environments.local;
}

export const environment = detectEnvironment();
